<template>
  <div class="modal-mask" v-if="visible">
    <div class="modal-wrapper">
      <div class="modal-container">
        <!-- TITLE -->
        <h4 class="modal-title">{{ $t('userAdmin.addNewFmg') }}</h4>

        <!-- INPUT FIELD -->
        <div class="form-group mt-3">
          <label>{{ $t('userAdmin.fmgName') }}</label>
          <input
            type="text"
            class="form-control"
            v-model="name"
            placeholder="Oulu South, Helsinki Itä, ..."
            @keyup.enter="submit"
          />
        </div>

        <!-- ACTION BUTTONS -->
        <div class="modal-footer mt-4">
          <sprbutton
            type="secondary"
            :size="4"
            :title="$t('common.cancel')"
            click-event="cancel"
            @cancel="cancel"
          />

          <sprbutton
            type="primary"
            :size="4"
            :title="$t('common.save')"
            :disabled="!name.trim()"
            click-event="save"
            @save="submit"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import Vue from 'vue'
import sprbutton from '../SPRButton.vue'

export default Vue.extend({
  name: 'CreateFmgModal',

  components: { sprbutton },

  props: {
    visible: { type: Boolean, required: true }
  },

  data() {
    return {
      name: ''
    }
  },

  watch: {
    visible(v: boolean) {
      if (v) this.name = '' // Reset on open
    }
  },

  methods: {
    submit() {
      const trimmed = this.name.trim()
      if (!trimmed) return
      this.$emit('create', trimmed)
    },

    cancel() {
      this.$emit('cancel')
    }
  }
})
</script>

<style lang="scss" scoped>
@import '~@/assets/scss/_variables.scss';

.modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.45);
  display: flex;
  align-items: center;
  justify-content: center;
}

.modal-wrapper {
  width: 100%;
  max-width: 450px;
}

.modal-container {
  background: $brand-white;
  padding: 20px;
  border-radius: 5px;
  box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.25);
}

.modal-title {
  font-family: 'Signa-Light';
  color: $brand-red;
  margin: 0;
}

.modal-footer {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
}
</style>
